import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Hammer } from "lucide-react";

export function Logo({ size = "md", light = false }) {
  const { settings } = useAuth();
  const h = size === "lg" ? "h-12" : "h-8";
  if (settings.has_logo) {
    return <img data-testid="app-logo" src={`${API}/public/logo?v=${settings.version}`} alt={settings.app_name} className={`${h} w-auto object-contain`} />;
  }
  return (
    <div data-testid="app-logo" className="flex items-center gap-2">
      <span className={`${h} aspect-square rounded-xl bg-emerald-600 text-white grid place-items-center`}>
        <Hammer className="w-1/2 h-1/2" />
      </span>
      <span className={`font-display font-extrabold tracking-tight ${size === "lg" ? "text-3xl" : "text-lg"} ${light ? "text-white" : "text-slate-900"}`}>
        {settings.app_name || "UKerja"}
      </span>
    </div>
  );
}
